/* src/styles/form.css */

.form-heading {
  margin-top: 0;
  margin-bottom: 2rem;
  color: var(--color-deep-navy);
  font-size: var(--font-3xl);
  font-weight: 600;
}

.form-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  position: relative;
  /* Useful for absolute positioning of error if desired, though inline is requested */
}

.form-label {
  display: block;
  text-align: left;
  font-size: var(--font-base);
  font-weight: 500;
  color: var(--color-medium-gray);
  margin-bottom: 6px;
}

.form-input {
  width: 100%;
  height: 40px;
  padding: 10px 12px;
  font-size: var(--font-base);
  line-height: 1.5;
  color: var(--color-deep-navy);
  background-color: var(--color-white);
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  transition: all 0.2s ease-in-out;
}

.form-input-textarea {
  width: 100%;
  height: 100px;
  padding: 10px 12px;
  font-size: var(--font-base);
  line-height: 1.5;
  color: var(--color-deep-navy);
  background-color: var(--color-white);
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  transition: all 0.2s ease-in-out;
}



.form-error {
  border-color: #ef4444;
}

.form-error:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
}

.form-error {
  font-size: var(--font-xs);
  text-align: left;
  color: #ef4444;
  margin-top: 4px;
  font-weight: 500;
}

/* Grid System & Layout */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.form-item-full {
  grid-column: 1 / -1;
}



.action-container {
  max-width: max-content;
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.action-container .btn {
width: calc(100% - 40px);
  min-width: 150px;
}

.login-form-item .action-container {
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  justify-content: stretch;
}

.login-form-item .action-container .btn {
  width: 100%;
}

.spacer {
  margin-top: 2rem;
}

.success-icon {
  background-color: #ecfdf5;
  color: #10b981;
}

.error-icon {
  background-color: #fef2f2;
  color: #ef4444;
}

.success-btn {
  background-color: #10b981;
}

.success-btn:hover {
  background-color: #059669;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

.success-btn:focus {
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.3);
}

.error-btn {
  background-color: #ef4444;
}

.error-btn:hover {
  background-color: #dc2626;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.error-btn:focus {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);
}

/* Step Indicator */
.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  margin-bottom: 3rem;
  padding: 0 1rem;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  opacity: 0.5;
  transition: all 0.3s ease;
}

.step-active {
  opacity: 1;
}

.step-number {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: var(--color-white);
  border: 2px solid var(--color-medium-gray);
  color: var(--color-medium-gray);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: var(--font-lg);
  transition: all 0.3s ease;
}

.step-active .step-number {
  background-color: var(--color-deep-navy);
  border-color: var(--color-deep-navy);
  color: var(--color-white);
  box-shadow: 0 0 0 4px rgba(92, 108, 228, 0.2);
}

.step-label {
  font-size: 0.875rem;
  text-align: center;
  font-weight: 600;
  color: var(--color-medium-gray);
}

.step-active .step-label {
  color: var(--color-deep-navy);
}

.step-divider {
  flex-grow: 1;
  height: 2px;
  background-color: var(--color-border);
  margin: 0 1.5rem;
  transform: translateY(-1.25rem);
}

/* chatbox */

.chatbox-logo-preview {
  width: calc(100px + 2vw);
  display: flex;
  height: calc(80px + 1.5vw);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .action-container {
    justify-content: stretch;
  }

  .action-container .btn {
    width: 100%;
  }

  .card {
    padding: 20px;
  }
}


@media (max-width: 480px) {
  .login-card {
    width: 100%;
    margin: 0 !important;
  }
  .action-container {
    flex-direction: column;
    max-width: 100%;
    margin-left: 0;
    justify-content: stretch;
    width: 100%;
  }
}